// src/components/resources/tools/generators/AdMockup/CreativeSlot.tsx
'use client'

import { PhotoIcon } from '@heroicons/react/24/outline'

/**
 * Fixed-ratio creative slot. Uses the padding-bottom ratio technique (not the
 * `aspect-ratio` CSS property) so the box reserves height even though its only
 * children are absolutely positioned — `aspect-ratio` collapses to zero height
 * with no in-flow content, and html2canvas doesn't honour it on export either.
 *
 * @param ratio height ÷ width (1 = square, 1/1.91 ≈ 0.5236 for a 1.91:1 link ad)
 */
export function CreativeSlot({ image, alt, ratio }: { image: string | null; alt: string; ratio: number }): JSX.Element {
  return (
    <div className="relative w-full overflow-hidden bg-slate-100 dark:bg-slate-800" style={{ paddingBottom: `${ratio * 100}%` }}>
      {image ? (
        // eslint-disable-next-line @next/next/no-img-element -- user-uploaded data URL; next/image can't optimize blob/data URIs and html2canvas needs the raw <img>
        <img src={image} alt={alt} className="absolute inset-0 h-full w-full object-cover" />
      ) : (
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 text-slate-400">
          <PhotoIcon className="h-10 w-10" />
          <span className="text-xs">Upload your ad creative</span>
        </div>
      )}
    </div>
  )
}
